export default [
  // Main Page
  {
    path: 'add-fee',
    name: 'website.add-fee',
    component: () => import('@/views/website/add-fee'),
  },
];
